module.exports = __webpack_public_path__ + "static/media/or.44b83586.svg";